import { academyApiUrl } from './academyBackend';
import { parseJsonResponse } from './leadsAPI';

async function parseAcademyJsonResponse(response) {
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.success === false) {
    throw new Error(result.message || result.error || 'Request failed');
  }
  return result;
}

export async function verifyAcademyContactLead(payload) {
  const response = await fetch(academyApiUrl('/api/contact-requests/verify'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      preferredContactMethod: payload.preferredContactMethod,
      phone: payload.phone,
      email: payload.email,
    }),
  });
  return parseAcademyJsonResponse(response);
}

export async function submitAcademyContactLead({
  fullName,
  preferredContactMethod,
  phone,
  countryCode,
  email,
  availableTimes,
  verificationCode,
}) {
  const response = await fetch(academyApiUrl('/api/contact-requests'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fullName,
      contactMethod: preferredContactMethod,
      phone: preferredContactMethod === 'phone' ? phone : '',
      countryCode: preferredContactMethod === 'phone' ? countryCode : '',
      email: preferredContactMethod === 'email' ? email : '',
      availableTimes,
      verificationCode,
    }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || result.error || 'Request failed');
  }
  return { success: true, ...result };
}
